import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProgressBarService {
  private visibilitySource = new BehaviorSubject<boolean>(false);
  progressBarVisibility = this.visibilitySource.asObservable();

  show() {
    this.visibilitySource.next(true);
  }

  hide() {
    this.visibilitySource.next(false);
  }
}



